import React, { FC } from 'react'
import { Helmet } from 'react-helmet'

interface TitleProps {
  title?: string
}

const Title: FC<TitleProps> = ({ title }) => {
  return (
    <Helmet>
      {/* TODO: Make this conditionally load an organization's configured Display Name */}
      {title ? <title>Ancho | {title}</title> : <title>Ancho</title>}
    </Helmet>
  )
}

export default Title
